export const GET_PROFILE_INITIATED = "GET_PROFILE_INITIATED";
export const GET_PROFILE_SUCCESS = "GET_PROFILE_SUCCESS";
export const GET_PROFILE_FAILED = "GET_PROFILE_FAILED";

export const UPDATE_PROFILE_INITIATED = "UPDATE_PROFILE_INITIATED";
export const UPDATE_PROFILE_SUCCESS = "UPDATE_PROFILE_SUCCESS";
export const UPDATE_PROFILE_FAILED = "UPDATE_PROFILE_FAILED";
export const RESET_STATE = "RESET_STATE";
